import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { Injector } from '@angular/core';
import { createCustomElement } from '@angular/elements';

import { AppComponent } from './app.component';
import { JustaFireComponent } from './fire/justa-fire.component';
import { MultiUserPickerComponent } from './multi-user-picker/multi-user-picker.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [
        AppComponent,
        JustaFireComponent,
        MultiUserPickerComponent
    ],
    entryComponents: [
        JustaFireComponent,
        MultiUserPickerComponent
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        // MultiUserPickerComponent need HttpClient in the constructor,
        // but we need to import HttpClientModule rather than HttpClient
        // which is weird

        FormsModule,       // this is needed for angular forms
        ReactiveFormsModule  // this is needed for angular forms
    ],
    providers: [],
    // bootstrap: [AppComponent]
    // must comment out this bootstrap for web component created from createCustomElement 
    // when you directly test it on index.html page
})

export class AppModule {
    constructor(private injector: Injector) {

    }

    ngDoBootstrap() {

        // this is key code to create web component:
        let el = createCustomElement(JustaFireComponent, { injector: this.injector });
        customElements.define('justa-fire', el);

        el = createCustomElement(MultiUserPickerComponent, { injector: this.injector });
        customElements.define('justa-user-picker', el);
    }

}
